import React, { useEffect, useMemo, useState } from "react";
import { AREA_OPTIONS, AREA_STATUS_OPTIONS } from "./config";
import PanelDropDown from "components/Common/Dropdowns/PanelDropDown";

const FilterArea = (props) => {
  const { filters, updateFilter, updateMultipleFilters } = props;

  const onDropdownChange = (value) => {
    updateMultipleFilters({
      keyword: value,
      text: "",
    });
  };

  const onSearchChange = (event) => {
    const { value } = event.target;
    if (value.trim() === "") {
      updateFilter("text", "");
    } else {
      updateFilter("text", value);
    }
  };

  const filterVal = useMemo(() => {
    return AREA_OPTIONS.find((option) => option.key === filters.keyword).value;
  }, [filters]);

  const statusVal = useMemo(() => {
    return AREA_STATUS_OPTIONS.find(
      (option) => option.key === filters.is_active
    ).value;
  }, [filters]);

  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;

  const [searchText, setSearchText] = useState(filters.text || "");

  const monthNames = useMemo(
    () => [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    []
  );

  useEffect(() => {
    if (!filters.year) {
      updateFilter("year", currentYear);
    }
    if (!filters.month) {
      updateFilter("month", monthNames[currentMonth - 1]);
    }
  }, [
    filters.year,
    filters.month,
    updateFilter,
    currentYear,
    currentMonth,
    monthNames,
  ]);

  const years = useMemo(() => {
    return Array.from({ length: 11 }, (_, i) => currentYear - 5 + i);
  }, [currentYear]);

  const months = useMemo(() => {
    return Array.from({ length: 12 }, (_, i) => i + 1);
  }, []);

  const setFilterValue = (keyname, value) => {
    updateFilter(keyname, value);
  };

  return (
    <>
      <div className="dropdown ms-3">
        <button
          className="dropdown-toggle btn btn-o active"
          data-bs-toggle="dropdown"
        >
          {filters.year || "Select Year"}
        </button>
        <ul className="dropdown-menu">
          {years.map((year) => (
            <li
              className="dropdown-item"
              key={year}
              onClick={() => updateFilter("year", year)}
            >
              {year}
            </li>
          ))}
        </ul>
      </div>

      <div className="dropdown ms-3">
        <button
          className="dropdown-toggle btn btn-o active"
          data-bs-toggle="dropdown"
        >
          {filters.month || "Select Month"}
        </button>
        <ul className="dropdown-menu">
          {monthNames.map((month) => (
            <li
              className="dropdown-item"
              key={month}
              onClick={() => updateFilter("month", month)}
            >
              {month}
            </li>
          ))}
        </ul>
      </div>

      <div className="ms-3" style={{ width: "250px" }}>
        <PanelDropDown
          setFilterValue={setFilterValue}
          showSuperFranchise={true}
          className="w-100"
        />
      </div>
    </>
  );
};
export default FilterArea;
